import { AlertRoundIcon, Asset } from '@clearcover/atlas';
import styles from './styles.module.css';
import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';

type FormErrorBannerPropsType = {
  message: string;
  actionButton?: ReactNode;
  className?: string;
};

export const FormErrorBanner: FC<FormErrorBannerPropsType> = ({
  message,
  actionButton,
  className,
}) => {
  return (
    <div className={styles.container} data-testid="form-error-banner">
      <div className={classnames(styles.errorMessageBanner, className)}>
        <Asset
          icon={AlertRoundIcon}
          className={styles.alertIcon}
          description="Form Error Alert Icon"
          height={16}
          width={16}
        />
        {message}
      </div>
      {actionButton}
    </div>
  );
};
